module.exports = __webpack_public_path__ + "img/advantage3@2x.46180c9a.png";